import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
function consultationUnavailable(): never {
  throw new Error("Consultation payments are temporarily unavailable. Please contact us to arrange your consultation.");
}

// Deliberately fail closed until the independent consultation lifecycle is certified.
// No appointment/payment read, provider call, capture, or write can run here.
export const createAppointmentPayment = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({
    appointmentId: z.string().uuid(),
    amountPaise: z.number().int().positive().optional(),
  }).parse(data))
  .handler(async (): Promise<{ id: string; appointment_id: string; keyId: string; razorpayOrderId: string; env: "test" | "live"; amountPaise: number }> => {
    return consultationUnavailable();
  });

export const verifyAppointmentPayment = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({
    paymentId: z.string().uuid(),
    razorpayOrderId: z.string().min(1).max(64),
    razorpayPaymentId: z.string().min(1).max(64),
    razorpaySignature: z.string().min(1).max(256),
  }).parse(data))
  .handler(async (): Promise<{ success: true }> => {
    return consultationUnavailable();
  });
